<template>
    <div>
        <div class="pac-input-wrapper">
            <input
                id="pac-input"
                class="controls"
                type="text"
                :placeholder="$t('Ingresa tu dirección aquí')"
                :style="`border: 2px solid ${btnColor}; border-radius: 4px;`"
            />
        </div>
        <button
            class="btn-current-location"
            type="button"
            :style="`background-color: ${btnColor};`"
            @click="useCurrentLocation"
        >
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="white" style="margin-right:6px;vertical-align:middle">
                <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5S10.62 6.5 12 6.5s2.5 1.12 2.5 2.5S13.38 11.5 12 11.5z"/>
            </svg>
            {{ $t('Usar ubicación actual') }}
        </button>
        <div id="map"></div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            map: null,
            markers: [],
            resultClick: {
                address: '',
                lat: null,
                lng: null
            }
        }
    },
    props: ['center', 'zoom', 'btnColor'],
    mounted() {
        this.initMap()
    },
    methods: {
        initMap() {
            // const BOLIVIA_BOUNDS = {
            //     north: -9.297798,
            //     south: -23.544301,
            //     west: -16.868110,
            //     east: -15.877288
            // }
            this.map = new window.google.maps.Map(document.getElementById("map"), {
                zoom: this.zoom,
                center: this.center,
                streetViewControl: false,
                mapTypeControl: false,
                mapTypeId: "roadmap",
                // restriction: {
                //   latLngBounds: BOLIVIA_BOUNDS,
                //   strictBounds: true
                // },
            });

            // search box
            const input = document.getElementById("pac-input");
            const searchBox = new window.google.maps.places.SearchBox(input);
            this.map.addListener('bounds_changed', () => {
                searchBox.setBounds(this.map.getBounds())
            })
            searchBox.addListener('places_changed', () => {
                const places = searchBox.getPlaces()
                if (places.length === 0) {
                return
                } // Clear out the old markers.
                this.markers.forEach(marker => {
                marker.setMap(null)
                })
                this.markers = [] // For each place, get the icon, name and location.
                const bounds = new window.google.maps.LatLngBounds()
                places.forEach(place => {
                if (!place.geometry) {
                    console.log('Returned place contains no geometry')
                    return
                }
                this.markers.push(
                    new window.google.maps.Marker({
                    map: this.map,
                    title: place.name,
                    position: place.geometry.location
                    })
                )
                // this.getLatLng(this.markers[0].position)
                this.addMarker(this.markers[0].position)
                if (place.geometry.viewport) {
                    // Only geocodes have viewport.
                    bounds.union(place.geometry.viewport)
                } else {
                    bounds.extend(place.geometry.location)
                }
                })
                this.map.fitBounds(bounds)
            })
            // end search box

            // Mapa básica
            // this.markers = new window.google.maps.Marker({
            //     position: { lat: -28.024, lng: 140.887 },
            //     map: this.map,
            // });
            this.map.addListener('click', event => {
                this.addMarker(event.latLng)
            })
            this.addMarker(this.center)
        },
        
        addMarker (location) {
            // console.log(location);
            this.deleteMarkers()
            const marker = new window.google.maps.Marker({
                position: location,
                // icon: 'url',
                map: this.map
            })
            this.markers.push(marker)
            this.getLatLng(location)
        }, // Sets the map on all markers in the array.
        deleteMarkers () {
            for (let i = 0; i < this.markers.length; i++) {
                this.markers[i].setMap(null)
            }
            this.markers = []
            this.resultClick.address = ''
        },
        useCurrentLocation() {
            if (!navigator.geolocation) {
                alert(this.$t('Geolocalización no disponible en este navegador'))
                return
            }
            navigator.geolocation.getCurrentPosition(
                (pos) => {
                    const latLng = new window.google.maps.LatLng(pos.coords.latitude, pos.coords.longitude)
                    this.map.setCenter(latLng)
                    this.map.setZoom(16)
                    this.addMarker(latLng)
                },
                () => {
                    alert(this.$t('No se pudo obtener la ubicación actual'))
                },
                { enableHighAccuracy: true, timeout: 8000, maximumAge: 0 }
            )
        },
        getLatLng (location) {
            // console.log(location);
            // geocoder
            // var myLatlngCurrent = new window.google.maps.LatLng(this.center.lat, this.center.lng)
            const geocoder = new window.google.maps.Geocoder()
            geocoder.geocode({ location: location }, (results, status) => {
                if (status === 'OK') {
                    if (results[0]) {
                        // console.log(results);
                        this.resultClick.address = results[0].formatted_address
                    } else {
                        alert(this.$t('Sin resultados'))
                    }
                } else {
                    alert(this.$t('El geocodificador falló debido a:') + ' ' + status)
                }
            })
            // obtenemos lat y lng
            if (typeof(location.lat) === 'number') {
                this.resultClick.lat = location.lat
                this.resultClick.lng = location.lng
            } else {
                const tmpLocation = location.toString()
                // (-15.54, -65.3434)
                const tmpReplace = tmpLocation.replace('(', '').replace(')', '')
                const coord = tmpReplace.split(', ')
                this.resultClick.lat = parseFloat(coord[0])
                this.resultClick.lng = parseFloat(coord[1])
            }
            // console.log(this.resultClick);
            setTimeout(() => {
                this.$emit('result-click', this.resultClick)
            }, 1000);
        },
    },
}
</script>
<style lang="scss">
#map {
  height: 350px;
}
.pac-input-wrapper {
  padding: 8px 8px 4px;
  background-color: #f5f5f5;
}
#pac-input {
  background-color: #fff;
  font-size: 15px;
  font-weight: 400;
  padding: 10px 14px;
  text-overflow: ellipsis;
  width: 100%;
  outline: 0 none;
  box-sizing: border-box;
  box-shadow: 0 2px 6px rgba(0,0,0,0.15);
}
.btn-current-location {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 9px 16px;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  border: none;
  cursor: pointer;
  letter-spacing: 0.3px;
  &:hover {
    filter: brightness(0.92);
  }
}
</style>